<script setup>

import {computed} from "vue";

const props = defineProps({
    newsletter: {
        type: Object,
        required: true,
    },
})

const senderName = computed(() => {
    return window.myflow?.company?.name ? window.myflow.company.name : ''
})

</script>

<template>
<div class="bg-white border rounded-wl overflow-hidden py-4">
    <div class="p-2 border-b flex flex-col">
        <div class="h-4 bg-gray-400 inline-block w-full max-w-36"></div>
        <div class="h-4 bg-gray-300 mt-2 inline-block w-full max-w-48"></div>
        <div class="h-3 bg-gray-200 mt-1 inline-block w-full max-w-72"></div>
    </div>
    <div
        v-if="newsletter"
        class="overflow-hidden px-2 transition-all border-b py-2"
    >
        <div
            class="font-bold"
        >
            {{ senderName }}
        </div>
        <div
            class="font-medium"
        >
            {{ newsletter.email_template.subject?.length > 0 ? newsletter.email_template.subject : 'Subject' }}
        </div>
        <div class="text-gray-500 text-xs whitespace-pre">
            {{ newsletter.email_template.preview_text?.length > 0 ? newsletter.email_template.preview_text : 'Preview text' }}
        </div>
    </div>
    <div class="p-2 flex flex-col">
        <div class="h-4 bg-gray-400 inline-block w-full max-w-24"></div>
        <div class="h-4 bg-gray-300 mt-2 inline-block w-full max-w-36"></div>
        <div class="h-3 bg-gray-200 mt-1 inline-block w-full max-w-48"></div>
        <div class="h-3 bg-gray-200 mt-1 inline-block w-full max-w-20"></div>
    </div>
</div>
</template>

<style scoped>

</style>
